// extracted by mini-css-extract-plugin
export default {"skillSlider":"Slider_skillSlider__L1Qji"};